import get from 'lodash/get';

import addProductTypes, {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from './types';

const initialState = {
  supplierList: {
    loading: false,
    data: [],
    error: '',
  },
  productCategories: {
    loading: false,
    data: [],
    error: '',
  },
  factoryList: {
    loading: false,
    data: [],
    error: '',
  },
  buyerList: {
    loading: false,
    data: [],
    error: '',
  },
  addProduct: {
    loading: false,
    data: {},
    error: '',
  },
  updateProduct: {
    loading: false,
    data: {},
    error: '',
  },
  createSupplier: {
    loading: false,
    data: {},
    error: '',
  },
  updateSupplier: {
    loading: false,
    data: {},
    error: '',
  },
  countryList: {
    loading: false,
    data: [],
    error: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypeRequest(addProductTypes.GET_SUPPLIERS): {
      return {
        ...state,
        supplierList: {
          ...state.supplierList,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.GET_SUPPLIERS): {
      return {
        ...state,
        supplierList: {
          loading: false,
          data: get(action, 'response.suppliers') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.GET_SUPPLIERS): {
      return {
        ...state,
        supplierList: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.GET_PRODUCT_CATEGORIES): {
      return {
        ...state,
        productCategories: {
          ...state.productCategories,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.GET_PRODUCT_CATEGORIES): {
      return {
        ...state,
        productCategories: {
          loading: false,
          data: get(action, 'response') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.GET_PRODUCT_CATEGORIES): {
      return {
        ...state,
        productCategories: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.GET_FACTORY_LIST): {
      return {
        ...state,
        factoryList: {
          ...state.factoryList,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.GET_FACTORY_LIST): {
      return {
        ...state,
        factoryList: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.GET_FACTORY_LIST): {
      return {
        ...state,
        factoryList: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.GET_BUYER_LIST): {
      return {
        ...state,
        buyerList: {
          ...state.buyerList,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.GET_BUYER_LIST): {
      return {
        ...state,
        buyerList: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.GET_BUYER_LIST): {
      return {
        ...state,
        buyerList: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.ADD_PRODUCT): {
      return {
        ...state,
        addProduct: {
          ...state.addProduct,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.ADD_PRODUCT): {
      return {
        ...state,
        addProduct: {
          loading: false,
          data: get(action, 'response') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.ADD_PRODUCT): {
      return {
        ...state,
        addProduct: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.UPDATE_PRODUCT): {
      return {
        ...state,
        updateProduct: {
          ...state.updateProduct,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.UPDATE_PRODUCT): {
      return {
        ...state,
        updateProduct: {
          loading: false,
          data: get(action, 'response') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.UPDATE_PRODUCT): {
      return {
        ...state,
        updateProduct: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.CREATE_SUPPLIER): {
      return {
        ...state,
        createSupplier: {
          ...state.createSupplier,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.CREATE_SUPPLIER): {
      return {
        ...state,
        createSupplier: {
          loading: false,
          data: get(action, 'response') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.CREATE_SUPPLIER): {
      return {
        ...state,
        createSupplier: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.UPDATE_SUPPLIER): {
      return {
        ...state,
        updateSupplier: {
          ...state.updateSupplier,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.UPDATE_SUPPLIER): {
      return {
        ...state,
        updateSupplier: {
          loading: false,
          data: get(action, 'response') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.UPDATE_SUPPLIER): {
      return {
        ...state,
        updateSupplier: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(addProductTypes.GET_COUNTRY_LIST): {
      return {
        ...state,
        countryList: {
          ...state.countryList,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(addProductTypes.GET_COUNTRY_LIST): {
      return {
        ...state,
        countryList: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(addProductTypes.GET_COUNTRY_LIST): {
      return {
        ...state,
        countryList: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }

    default:
      return state;
  }
};
